import { z } from 'zod';
import { BaseValidatorSchema } from '../base-validator-schema';

export const DocumentSizeValidator = z.literal('documentSize');
export type TDocumentSizeValidator = z.infer<typeof DocumentSizeValidator>;

export const DocumentSizeValidatorParamsSchema = z.object({
  fileSizeLimit: z.number().optional(),
});

export type TDocumentSizeValidatorParams = z.infer<typeof DocumentSizeValidatorParamsSchema>;

export const DocumentSizeValidatorSchema = BaseValidatorSchema.extend({
  type: DocumentSizeValidator,
  value: DocumentSizeValidatorParamsSchema.optional(),
});
